module.exports = "<div class=\"container\">\n  <div class=\"page-content\">\n    <div class=\"user-right\">\n      <div class=\"row\">\n        <div class=\"col-md-12 text-center\">\n          <div class=\"row\">&nbsp;</div>\n          <div class=\"row info-icon\">\n            <img src=\"assets/cancel-icon.jpg\" />\n            <h2>{{'payment' | translate }} {{'cancelled' | translate }} </h2>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/donation/donatio-return-url/donation-cancel.component.html
// module id = ./src/app/donation/donatio-return-url/donation-cancel.component.html
// module chunks = main